import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";
import { BaseBus } from "./BaseBus";
export class LaborRateBus extends BaseBus{
    constructor(busObj: LaborRateBus) {
        super(busObj);

    }
    CID(): any {
        return this.laborRateId;
    }
    setId(id: any) {
        this.laborRateId = id;
    }
    initialize(data: LaborRateBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setParentId(id: any) {
        //this.laborRateId = id;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: LaborRateBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }

    }
    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        this.updateDt = date;
        if (this.hasId) {
            this.updateUserId = userId;

        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }
    }
    laborRateId:string;
    local:string;
    foreMan:number;
    journeyMan:number;
    tradesMan:number;
    apprentice:number;
    regionId:string;
    regionName:string;
    burden:number;
    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    isActive: boolean;
    canDelete: boolean;
}